/** The machine-readable codes of the API errors, which the app translates. The list only grows. */
export const API_ERROR_CLIENT_MESSAGES = {
  talent_not_found: "Ton profil est introuvable.",
  timesheet_period_not_found: "Cette période est introuvable.",
  timesheet_day_not_found: "Ce jour est introuvable.",
  timesheet_week_not_found: "Cette semaine est introuvable.",
  timesheet_proof_not_found: "Ce justificatif est introuvable.",
  contract_not_found: "Ce contrat est introuvable.",
  timesheet_v2_not_open: "Tes relevés d'heures passent encore par l'ancienne version de l'app.",
  timesheet_maintenance: "Les relevés d'heures sont en maintenance. Réessaie dans quelques minutes.",
  invalid_request: "La requête est invalide. Veuillez vérifier les informations saisies.",
  contract_not_signed: "Ce contrat n'est pas encore signé.",
  paper_timesheet: "Les heures de ce contrat passent par une feuille papier.",
  period_not_editable: "Cette période ne peut plus être modifiée.",
  future_day: "Tu ne peux pas saisir les heures d'un jour à venir.",
  invalid_minutes: "Les heures saisies sont invalides.",
  weekly_minutes_exceeded: "Les heures saisies dépassent le maximum autorisé.",
  date_out_of_contract_range: "Ce jour est hors des dates de ton contrat.",
  week_not_started: "Cette semaine n'a pas encore commencé.",
  periods_not_same_week: "Ces périodes ne sont pas de la même semaine.",
  period_not_ended: "Cette période n'est pas encore terminée.",
  unsupported_file_type: "Ce type de fichier n'est pas accepté.",
  file_too_small: "Le fichier est trop petit et ne semble pas être un document valide.",
  file_too_large: "Le fichier envoyé dépasse les limites autorisées.",
  worksite_signature_not_allowed: "Cette semaine ne peut pas être validée sur le chantier.",
  worksite_signer_not_allowed: "Ce responsable ne peut pas valider tes heures.",
  signer_is_talent: "Tu ne peux pas valider tes propres heures.",
  no_period_to_validate: "Aucune période de cette semaine n'est à valider.",
} as const;

export type ApiErrorCode = keyof typeof API_ERROR_CLIENT_MESSAGES;
